import React, { useState } from "react";
import api from "../../api/axios";
import { Button, Stack } from "@mui/material";
import ReportFilterBar from "../../components/reports/ReportFilterBar";
import ReportTable from "../../components/reports/ReportTable";

export default function EffortSummaryReport() {

  const [rows, setRows] = useState([]);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    user: ""
  });

  const fetchData = async () => {
    try {

      const params = {
        startDate: filters.startDate,
        endDate: filters.endDate
      };

      // only send user if selected
      if (filters.user) {
        params.user = filters.user;
      }

      const res = await api.get("/api/reports/effort-summary", {
        params
      });

      console.log("EFFORT SUMMARY RESPONSE:", res.data);

      let data = [];

      if (Array.isArray(res.data.summary)) {
        data = res.data.summary;
      } 
      else if (Array.isArray(res.data.rows)) {
        data = res.data.rows;
      } 
      else if (Array.isArray(res.data.data)) {
        data = res.data.data;
      } 
      else if (Array.isArray(res.data)) {
        data = res.data;
      }

      setRows(data);

    } catch (err) {

      console.error("Effort Summary Fetch Error:", err);
      setRows([]);

    }
  };

  const exportExcel = () => {

    const url =
      `http://localhost:5000/api/reports/effort-summary/export` +
      `?startDate=${filters.startDate || ""}` +
      `&endDate=${filters.endDate || ""}` +
      `&user=${filters.user || ""}` +
      `&format=excel`;

    window.open(url, "_blank");

  };

  const exportPDF = () => {

    const url =
      `http://localhost:5000/api/reports/effort-summary/export` +
      `?startDate=${filters.startDate || ""}` +
      `&endDate=${filters.endDate || ""}` +
      `&user=${filters.user || ""}` +
      `&format=pdf`;

    window.open(url, "_blank");

  };

  const columns = [
    { field: "user", header: "User" },
    { field: "total_hours", header: "Total Hours" },
    { field: "total_logs", header: "Total Logs" }
  ];

  return (
    <>
      <h2>Effort Summary Report</h2>

      <ReportFilterBar
        filters={["startDate", "endDate", "user"]}
        values={filters}
        onChange={setFilters}
        onFetch={fetchData}
      />

      <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>

        <Button variant="outlined" onClick={exportExcel}>
          Export Excel
        </Button>

        <Button variant="outlined" onClick={exportPDF}>
          Export PDF
        </Button>

      </Stack>

      <ReportTable
        columns={columns}
        rows={rows}
      />
    </>
  );
}